import api from './api'

export const coupon = {
  sellerList: (params) => {
    return api.post(`/CloudParkAPI/Coupon/GetSellerList`, params)
  },
  saveSeller: (params) => {
    return api.post(`/CloudParkAPI/Coupon/SaveSeller`, params)
  },
  deleteSeller: (params) => {
    return api.post(`/CloudParkAPI/Coupon/DeleteSeller`, params)
  },
  synSellerById: (params) => {
    return api.post(`/CloudParkAPI/Coupon/SynSellerById`, params)
  },
  getSellerPers: (params) => {
    return api.post(`/CloudParkAPI/Coupon/GetSellerPers`, params)
  },
  saveSellerPers: (params) => {
    return api.post(`/CloudParkAPI/Coupon/SaveSellerPers`, params)
  },
  getSellerListByCustIDAsync: (params) => {
    return api.post(`/CloudParkAPI/Coupon/GetSellerListByCustIDAsync`, params)
  },
  editPwd: (params) => {
    return api.post(`/CloudParkAPI/Coupon/EditPwd`, params)
  },
  couponTypeList: (params) => {
    return api.post(`/CloudParkAPI/CouponType/GetCouponTypeList`, params)
  },
  saveCouponType: (params) => {
    return api.post(`/CloudParkAPI/CouponType/SaveCouponType`, params)
  },
  deleteCouponType: (params) => {
    return api.post(`/CloudParkAPI/CouponType/DeleteCouponType`, params)
  },
  synCouponTypeById: (params) => {
    return api.post(`/CloudParkAPI/CouponType/SynCouponTypeById`, params)
  },
  getTypeList: (params) => {
    return api.post(`/CloudParkAPI/CouponType/GetTypeList`, params)
  },
  getCouponNameList: (params) => {
    return api.post(`/CloudParkAPI/CouponType/GetCouponNameList`, params)
  },
  couponBatchList: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/GetCouponBatchList`, params)
  },
  saveCouponBatch: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/SaveCouponBatch`, params)
  },
  deleteCouponBatch: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/DeleteCouponBatch`, params)
  },
  synCouponBatchById: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/SynCouponBatchById`, params)
  },
  createBatchData: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/CreateBatchData`, params)
  },
  getCouponBatchDetail: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/GetCouponBatchDetail`, params)
  },
  printCouponByID: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/PrintCouponByID`, params)
  },
  printCouponList: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/PrintCouponList`, params)
  },
  updatePrintCoupon: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/UpdatePrintCoupon`, params)
  },
  updatePrintCouponList: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/UpdatePrintCouponList`, params)
  },
  createQCode: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/CreateQCode`, params)
  },
  createDynamicQCode: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/CreateDynamicQCode`, params)
  },
  couponBatchToInvalid: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/CouponBatchToInvalid`, params)
  },
  getCoupponGroupPageList: (params) => {
    return api.post(`/CloudParkAPI/CouponGroup/GetCoupponGroupPageList`, params)
  },
  saveCouponGroup: (params) => {
    return api.post(`/CloudParkAPI/CouponGroup/SaveCouponGroup`, params)
  },
  deleteCouponGroup: (params) => {
    return api.post(`/CloudParkAPI/CouponGroup/DeleteCouponGroup`, params)
  },
  synCouponGroupById: (params) => {
    return api.post(`/CloudParkAPI/CouponGroup/SynCouponGroupById`, params)
  },
  getCouponGroupList: (params) => {
    return api.post(`/CloudParkAPI/CouponGroup/GetCouponGroupList`, params)
  },
  getSellerGroupPageList: (params) => {
    return api.post(`/CloudParkAPI/SellerGroup/GetSellerGroupPageList`, params)
  },
  saveSellerGroup: (params) => {
    return api.post(`/CloudParkAPI/SellerGroup/saveSellerGroup`, params)
  },
  deleteSellerGroup: (params) => {
    return api.post(`/CloudParkAPI/SellerGroup/deleteSellerGroup`, params)
  },
  synSellerGroupById: (params) => {
    return api.post(`/CloudParkAPI/SellerGroup/synSellerGroupById`, params)
  },
  getSellerGroupList: (params) => {
    return api.post(`/CloudParkAPI/SellerGroup/GetSellerGroupList`, params)
  },
  getRechargeCouponList: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/GetRechargeCouponList`, params)
  },
  saveRechargeCoupon: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/SaveRechargeCoupon`, params)
  },
  deleteRechargeCoupon: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/DeleteRechargeCoupon`, params)
  },
  deleteCouponBatchTemplate: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/DeleteCouponBatchTemplate`, params)
  },
  nullifyRechargeCoupon: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/NullifyRechargeCoupon`, params)
  },
  rechargeCoupon: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/RechargeCoupon`, params)
  },
  getRechargeCouponTemplateList: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/GetRechargeCouponTemplateList`, params)
  },
  getRechargeCouponListAsync: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/GetRechargeCouponListAsync`, params)
  },
  getRechargeCoupon: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/GetRechargeCoupon`, params)
  },
  saveRechargeCouponTemplateh: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/SaveRechargeCouponTemplateh`, params)
  },
  rechargeList: (params) => {
    return api.post(`/CloudParkAPI/CouponBatch/RechargeList`, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/coupon.js